import { Resolve } from "@angular/router";
import { Injectable } from "@angular/core";
import { Keys, StorageService } from "../../../../service/storage.service";
import { UserAttributeInterface } from "../../../../model/finzy-flex/user-attribute.model";
import { UserAttributeService } from "../../../../service/finzy-flex/user/user-attribute.service";

@Injectable()
export class UserAttributeResolver implements Resolve<UserAttributeInterface | null> {
    private readonly userAttributeService: UserAttributeService;
    private readonly storageService: StorageService;

    constructor(userAttributeService: UserAttributeService, storageService: StorageService) {
        this.userAttributeService = userAttributeService;
        this.storageService = storageService;
    }

    public async resolve(): Promise<UserAttributeInterface | null> {
        const profileId = this.storageService.getItem(Keys.PROFILE_ID);
        const userAttribute = this.userAttributeService.getUserAttributesById(profileId);
        return userAttribute ? userAttribute : null;
    }

}